import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import PrePurchaseInspection from "../pages/services/pre-purchase-inspection/page";
import LocationNY from "../pages/location/new-york/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/services/pre-purchase-inspection",
    element: <PrePurchaseInspection />,
  },
  {
    path: "/location/new-york",
    element: <LocationNY />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
